import { request } from "../axios/request";
import {
  FETCH_TOKEN_REJECTED,
  FETCH_TOKEN_FULFILLED,
  SIGN_IN_REJECTED
} from "../constants/signin";

export const tokenRejected = error => ({
  type: FETCH_TOKEN_REJECTED,
  error
});

export const rejected = error => ({
  type: SIGN_IN_REJECTED,
  error
});

export const tokenFulfilled = response => ({
  type: FETCH_TOKEN_FULFILLED,
  response
});

export const fetchToken = (url, data = {}) => dispatch => {
  request({
    method: "POST",
    url,
    data
  })
    .then(response => {
      dispatch(signIn(response.data.redirect_url));
    })
    .catch(error => {
      dispatch(tokenRejected(error));
    });
};

export const signIn = url => dispatch => {
  request({ method: "get", url })
    .then(response => {
      dispatch(tokenFulfilled(response.data));
    })
    .catch(error => {
      dispatch(rejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/signin.js